<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo">
        <div v-else class="sidebar-title">{{info.hosSys}}</div> -->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" src="~@/assets/img/logo.png" class="sidebar-logo">
      </router-link>
    </transition>
  </div>
</template>

<script>
import { getHospitalInfo } from '@/api/baseInfo'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  created(){
    this.getHospitalInfo()
  },
  data() {
    return {
      title: '彭州欣元慢性病医院',
      logo: '~@/assets/img/logo.png',
      info: {}
    }
  },
  methods: {
    async getHospitalInfo () {
      const res = await getHospitalInfo()
      this.info = res.data
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 240px;
      height: 68px;
      vertical-align: middle;
      margin-right: 12px;
      margin: 20px 0;
      padding: 0 12px
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #4281FF;
      line-height: 34px;
      font-size: 26px;
      padding: 20px 14px;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
